import { useHistory, Link } from "react-router-dom";
import { useContext, useEffect, useState, useRef } from "react";
import { UserContext } from "../providers/userData";
import { AppDataContext } from "../providers/appData";
import { FormContext } from "../providers/formValues";
import loadingSmall from "../icons/loadingSmall.svg";
import CurrencyFormat from "../helper/CurrencyFormat";
import Layout from "../Layout";
import { toast } from "react-toastify";
import copy from "../icons/copy.svg";

function QuickFund() {
  const { user } = useContext(UserContext);
  const { appData } = useContext(AppDataContext);
  const { formData, formDispatch } = useContext(FormContext);
  const [sending, setSending] = useState(false);

  const history = useHistory();
  document.title = "Fund Wallet with Quick Transfer-" + appData.business.name;
  const Copy = (text) => {
    navigator.clipboard.writeText(text).then(() => toast("Copied"));
  };
  const formOnChange = (e) => {
    formDispatch({
      type: "INPUTVALUES",
      data: { name: e.target.name, value: e.target.value },
    });
  };

  useEffect(() => {
    formDispatch({
      type: "INPUTVALUES",
      data: {
        name: "Alert",
        value: { isOpen: false, message: "" },
      },
    });
  }, []);

  const handleSubmit = (e) => {
    e.persist();
    e.preventDefault();
    setSending(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + user.token);
    var urlencoded = new URLSearchParams();
    urlencoded.append("amount", String(formData.amount));
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      //redirect: "follow",
    };
    fetch(
      localStorage.getItem("apiURL") + "fund_wallet_xendify",
      requestOptions
    )
      .then((response) => (response = response.text()))
      .then((response) => {
        const data = JSON.parse(response);
        setSending(false);
        if (data.status === "success") {
          formDispatch({
            type: "INPUTVALUES",
            data: {
              name: "xendifyData",
              value: data.data,
            },
          });
        } else if (
          data.message === "Token Expired" ||
          data.message === "User Not Found"
        ) {
          history.push("/signout");
        } else {
          formDispatch({
            type: "INPUTVALUES",
            data: {
              name: "Alert",
              value: { isOpen: true, message: data.message, type: "error" },
            },
          });
        }
      })
      .catch((error) => {
        formDispatch({
          type: "INPUTVALUES",
          data: {
            name: "Alert",
            value: {
              isOpen: true,
              message: "unable to connect to server",
              type: "error",
            },
          },
        });
        setSending(false);
      });
  };

  const CountdownTimer = ({ targetTime }) => {
    const [timeLeft, setTimeLeft] = useState("00:00");

    useEffect(() => {
      var target = new Date(targetTime).getTime();
      const interval = setInterval(() => {
        const now = Date.now();
        const diff = target - now;

        if (diff <= 0) {
          setTimeLeft("00:00");
          clearInterval(interval);
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
        const seconds = String(totalSeconds % 60).padStart(2, "0");

        setTimeLeft(`${minutes}:${seconds}`);
      }, 1000);

      return () => clearInterval(interval);
    }, [targetTime]);

    return timeLeft;
  };

  function XendifyForm() {
    useEffect(() => {
      const interval = setInterval(() => {
        checkTransaction();
      }, 5000);

      const checkTransaction = () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + user.token);
        var requestOptions = {
          method: "GET",
          headers: myHeaders,
        };
        fetch(
          localStorage.getItem("apiURL") +
            "transactions/" +
            formData.xendifyData.reference,
          requestOptions
        )
          .then((response) => (response = response.text()))
          .then((response) => {
            const data = JSON.parse(response);
            setSending(false);
            if (data.status === "success") {
              if (data.data.status_text === "SUCCESSFUL") {
                formDispatch({
                  type: "INPUTVALUES",
                  data: {
                    name: "Alert",
                    value: {
                      isOpen: true,
                      message: "Transfer Received!",
                      show: true,
                    },
                  },
                });
                clearInterval(interval); // ✅ Stop polling on success
              }
            } else if (
              data.message === "Token Expired" ||
              data.message === "User Not Found"
            ) {
              history.push("/signout");
            } else {
              formDispatch({
                type: "INPUTVALUES",
                data: {
                  name: "Alert",
                  value: { isOpen: true, message: data.message, type: "error" },
                },
              });
            }
          })
          .catch((error) => {
            formDispatch({
              type: "INPUTVALUES",
              data: {
                name: "Alert",
                value: {
                  isOpen: true,
                  message: "unable to connect to server",
                  type: "error",
                },
              },
            });
            setSending(false);
          });
      };
      return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
      <>
        <div className="divide-y-2 divide-primary-gray">
          <div className="flex flex-col mt-8 space-y-3.5 pb-9">
            <h6 className="text-center fs-1">
              Instantly Fund your wallet with a one time Account
            </h6>
            <div>
              <p className="font-medium  text-sm text-gray-700 dark:text-gray-200 md:text-base">
                Bank
              </p>
              <p className="font-semibold text-md dark:text-gray-200 text-gray-900 md:text-base ">
                {formData.xendifyData?.bank_name}
              </p>
            </div>

            <div>
              <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
                Account Number
              </p>
              <p className="font-semibold text-md text-gray-900 dark:text-gray-200 md:text-base flex ">
                {formData.xendifyData?.account_number}{" "}
                <label
                  className="text-xx flex mx-2 mt-1"
                  onClick={() => Copy(formData.xendifyData?.account_number)}
                >
                  copy <img src={copy} alt="copy" />
                </label>
              </p>
            </div>

            <div>
              <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
                Account Name
              </p>
              <p className="font-semibold text-md dark:text-gray-200 text-gray-900 md:text-base ">
                {formData.xendifyData?.account_name}
              </p>
            </div>

            <div>
              <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
                Amount
              </p>
              <p className="font-semibold text-md  dark:text-gray-200 text-gray-900 md:text-base ">
                ₦{CurrencyFormat(formData.amount)}
              </p>
            </div>
          </div>
          <div className="pt-2  "></div>
        </div>
        <div className="flex flex-col ">
          {!formData.moneySent ? (
            <div>
              <p className="font-medium text-sm text-red-700 dark:text-red-500 md:text-base text-center">
                <b> This account is for this transaction only.</b>
              </p>
              <p className="font-medium text-sm text-dark-700   md:text-base text-center">
                Expires in{" "}
                <b>
                  {" "}
                  {formData.xendifyData?.accountExpiry && (
                    <CountdownTimer
                      targetTime={formData.xendifyData?.accountExpiry}
                    />
                  )}
                </b>
              </p>
              <ExpiringClock />
              <span className="block w-full rounded-md shadow-sm text-center">
                <button
                  onClick={() => {
                    formDispatch({
                      type: "INPUTVALUES",
                      data: {
                        name: "moneySent",
                        value: true,
                      },
                    });
                  }}
                  className="py-2 px-4 md:py-4 md:px-8 bg-primary-orange hover:bg-primary-orange focus:ring-primary-orange focus:ring-offset-indigo-200 text-white w-full transition ease-in duration-200 text-center text-base  md:text-lg font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg mt-6"
                >
                  I've sent the money
                </button>
              </span>
            </div>
          ) : (
            <div>
              <p className="font-medium text-sm text-dark-800 dark:text-gray-100 md:text-base text-center">
                <b> Receiving your transfer...</b>
              </p>
              <div className="container flex flex-box">
                <TransferInProgress />
              </div>
              <p className="font-medium text-sm text-dark-700  md:text-base text-center">
                You can leave this page, we will fund your wallet and notify you
                once transfer is received
              </p>
            </div>
          )}
        </div>
      </>
    );
  }

  const TransferInProgress = () => {
    return (
      <div style={styles.container}>
        <div
          style={{
            right: 30,
            fontSize: "48px",
          }}
        >
          🏦
        </div>
        <div style={styles.arrow}>➖➖➖➖</div>
        <div
          style={{
            position: "absolute",
            right: 0,
            fontSize: "48px",
            paddingRight: "20px",
          }}
        >
          💼
        </div>
        {/* Embedded styles */}
        <style>
          {`
          @keyframes moveArrow {
            from {
              left: 60px;
              opacity: 0;
            }
            25% {
              opacity: 1;
            }
            75% {
              opacity: 1;
            }
             
            to {
              left: 70%;
              opacity: 0;
            }
          }
        `}
        </style>
      </div>
    );
  };

  const ExpiringClock = () => {
    return (
      <div style={{ width: 70, height: 80, margin: "auto" }}>
        <svg width="100%" height="100%" viewBox="0 0 100 100">
          {/* Stopwatch button nub */}
          <rect
            x="40"
            y="0"
            width="20"
            height="13"
            rx="2"
            fill={appData.business.primary_color}
          />

          {/* Circle outline */}
          <circle
            cx="50"
            cy="58"
            r="45"
            stroke={appData.business.primary_color}
            strokeWidth="5"
            fill="none"
          />

          {/* Center dot */}
          <circle cx="50" cy="58" r="2" fill="#333" />

          {/* Rotating clock hand */}
          <line
            className="clock-hand"
            x1="50"
            y1="58"
            x2="50"
            y2="23"
            stroke="#333"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>

        {/* Inline or external CSS animation */}
        <style>
          {`
          .clock-hand {
            transform-origin: 50% 58%;
            animation: spin 10s linear infinite;
          }

          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
        </style>
      </div>
    );
  };

  return (
    <Layout PageName={"Fund via Quick Bank Transfer"}>
      {!formData.xendifyData && (
        <>
          <div className="divide-y-2 divide-primary-gray">
            <div className="flex flex-col mt-8 space-y-3.5 pb-9">
              <h6 className="text-center fs-1">
                Instantly Fund your wallet with a one time Account
              </h6>
              <div className="flex justify-between ">
                {" "}
                <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
                  Status:
                </p>
                <p className="font-semibold text-sm text-red-500 md:text-base ">
                  {appData.master_settings.fund_status_bank * 1 === 0 ? (
                    <p className="font-semibold text-sm text-green-500 ">
                      Working
                    </p>
                  ) : (
                    <p className="font-semibold text-sm text-red-500 ">
                      Downtime
                    </p>
                  )}
                </p>
              </div>
              <div className="flex justify-between ">
                {" "}
                <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
                  Delivery time:
                </p>
                <p className="font-semibold text-sm text-gray-700 dark:text-gray-200 md:text-base">
                  1 - 3 Minutes
                </p>
              </div>
              <div className="flex justify-between ">
                {" "}
                <p className="font-medium text-sm text-gray-700 dark:text-gray-200 md:text-base">
                  Transaction Fee:
                </p>
                <p className="font-semibold text-sm text-gray-700 dark:text-gray-200 md:text-base">
                  ₦26.75
                </p>
              </div>
            </div>
            <div className="pt-4  "></div>
          </div>
          <div className="flex flex-col ">
            <form onSubmit={handleSubmit}>
              <div className="w-full">
                <div className=" relative ">
                  <label>
                    <p className="mt-4 font-medium text-gray-700 dark:text-gray-200 text-sm md:text-base">
                      Amount to Fund
                    </p>
                    <input
                      name="amount"
                      type="text"
                      key="amount"
                      required
                      inputMode="numeric"
                      pattern="^([5-9]\d|[1-9]\d{2,})$"
                      autoComplete="off"
                      className=" rounded-lg    flex-1 appearance-none border border-slate-300 w-full py-2 px-4 md:py-4 md:px-8 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-primary-orange focus:   mt-3.5"
                      placeholder={"Enter amount-Min ₦50 "}
                      value={formData.amount}
                      onChange={(e) => {
                        formOnChange(e);
                      }}
                    />
                  </label>
                </div>
              </div>
              <div>
                <span className="block w-full rounded-md shadow-sm text-center">
                  <button
                    type="submit"
                    className="py-2 px-4 md:py-4 md:px-8 bg-primary-orange hover:bg-primary-orange focus:ring-primary-orange focus:ring-offset-indigo-200 text-white w-full transition ease-in duration-200 text-center text-base  md:text-lg font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg mt-6"
                  >
                    {sending ? (
                      <div className="flex items-center justify-center">
                        <img
                          src={loadingSmall}
                          alt="loading ..."
                          className="w-7 h-7 "
                        />
                      </div>
                    ) : (
                      ` Proceed`
                    )}
                  </button>
                </span>
              </div>
            </form>
          </div>
        </>
      )}
      {formData.xendifyData && <XendifyForm />}
    </Layout>
  );
}

const styles = {
  container: {
    width: "100%",
    height: "100px",
    display: "flex",
    alignItems: "center",
  },
  arrow: {
    fontSize: "30px",
    position: "absolute",
    animation: "moveArrow 1.5s linear infinite",
  },
};
export default QuickFund;
